/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_GlobalCodes_BulkReorderGlobalCodesDto } from '../models/Routemize_DTOs_GlobalCodes_BulkReorderGlobalCodesDto';
import type { Routemize_DTOs_GlobalCodes_CreateGlobalCodeDto } from '../models/Routemize_DTOs_GlobalCodes_CreateGlobalCodeDto';
import type { Routemize_DTOs_GlobalCodes_GlobalCodeDto } from '../models/Routemize_DTOs_GlobalCodes_GlobalCodeDto';
import type { Routemize_DTOs_GlobalCodes_GlobalCodeDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_GlobalCodes_GlobalCodeDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_GlobalCodes_UpdateGlobalCodeDto } from '../models/Routemize_DTOs_GlobalCodes_UpdateGlobalCodeDto';
import type { Routemize_DTOs_MasterDataResult } from '../models/Routemize_DTOs_MasterDataResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MasterDataService {
    /**
     * @param keys
     * @param includeDefault
     * @returns Routemize_DTOs_MasterDataResult OK
     * @throws ApiError
     */
    public static getApiAppMasterDataGet(
        keys?: string,
        includeDefault: boolean = false,
    ): CancelablePromise<Array<Routemize_DTOs_MasterDataResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/masterData/get',
            query: {
                'keys': keys,
                'includeDefault': includeDefault,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAppMasterDataKeys(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/masterData/keys',
        });
    }
    /**
     * @param filterText
     * @param gcCode
     * @param categoryCode
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_GlobalCodes_GlobalCodeDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppMasterDataGetList(
        filterText?: string,
        gcCode?: string,
        categoryCode?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/masterData/getList',
            query: {
                'FilterText': filterText,
                'GCCode': gcCode,
                'CategoryCode': categoryCode,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_GlobalCodes_GlobalCodeDto OK
     * @throws ApiError
     */
    public static getApiAppMasterDataGet1(
        id: string,
    ): CancelablePromise<Routemize_DTOs_GlobalCodes_GlobalCodeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/masterData/{id}/get',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_GlobalCodes_GlobalCodeDto OK
     * @throws ApiError
     */
    public static postApiAppMasterDataCreate(
        requestBody?: Routemize_DTOs_GlobalCodes_CreateGlobalCodeDto,
    ): CancelablePromise<Routemize_DTOs_GlobalCodes_GlobalCodeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/masterData/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns Routemize_DTOs_GlobalCodes_GlobalCodeDto OK
     * @throws ApiError
     */
    public static putApiAppMasterDataUpdate(
        id: string,
        requestBody?: Routemize_DTOs_GlobalCodes_UpdateGlobalCodeDto,
    ): CancelablePromise<Routemize_DTOs_GlobalCodes_GlobalCodeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/masterData/{id}/update',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppMasterDataDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/masterData/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppMasterDataBulkReorder(
        requestBody?: Routemize_DTOs_GlobalCodes_BulkReorderGlobalCodesDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/masterData/bulkReorder',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppMasterDataBulkDelete(
        requestBody?: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/masterData/bulkDelete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
